import config from '../../config.json';

export const getNumItems = (cart: Shopify.Cart | undefined): number =>
  cart ? cart.lines.edges.reduce((prev, curr) => prev + curr.node.quantity, 0) : 0;

export const getShippingRate = (cart: Shopify.Cart | undefined): number =>
  config.shipping.base + (getNumItems(cart) - 1) * config.shipping.additional;

export const getPricePerQuantity = (price: string, quantity: number): string =>
  (parseFloat(price) * quantity).toFixed(2);

export const getQtyOfProductInCart = (cart: Shopify.Cart | undefined, productName: string): number => {
  if (!cart) return 0;

  const matchingProductTitle =
    cart?.lines && cart?.lines.edges.find((item) => item.node.merchandise.product.title === productName);
  if (matchingProductTitle) {
    return matchingProductTitle.node.quantity;
  }
  return 0;
};
